export default __webpack_public_path__ + "static/media/transportefletespiche2.14467f8e.jpg";